// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.targetPrice-chart-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.targetPrice-chart-wrapper {
  min-width: 0;
  flex: auto;
  height: 175px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/TargetChart/TargetChart.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,aAAa;AACf","sourcesContent":[".targetPrice-chart-container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n}\n\n.targetPrice-chart-wrapper {\n  min-width: 0;\n  flex: auto;\n  height: 175px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
